<div class="retrieval-test-modal bg-light-surface dark:bg-dark-surface flex flex-col">
  <!-- Header -->
  <div class="flex flex-row justify-between">
    <h1 class="flex items-center gap-2 !mb-0 flex-wrap">
      <lucide-angular [img]="FlaskConical" class="w-5 h-5 text-light-primary dark:text-dark-primary"></lucide-angular>
      Probar KB
      <span class="px-4 py-1.5 text-sm font-semibold rounded-full bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary">
        {{ data.kbName }}
      </span>
      @if (data.excludeIdentifier) {
        <span class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-full bg-light-bg-secondary dark:bg-dark-bg-secondary text-light-text-secondary dark:text-dark-text-secondary border border-light-border dark:border-dark-border">
          <lucide-angular [img]="Search" class="w-3.5 h-3.5"></lucide-angular>
          {{ data.excludeIdentifier }}
        </span>
      }
    </h1>
    <button mat-icon-button (click)="close()">
      <lucide-angular [img]="X" class="w-5 h-5 text-light-text-tertiary dark:text-dark-text-tertiary"></lucide-angular>
    </button>
  </div>

  <mat-dialog-content class="flex-1 !px-0 !pt-0  dark:[color-scheme:dark]">

    <!-- Form -->
    <form [formGroup]="articleForm" class="flex gap-3 items-start pt-4 pb-2">
      <mat-form-field appearance="fill" class="flex-1">
        <mat-label>Pregunta</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          formControlName="question"
          placeholder="Ej: ¿Cuáles son los horarios de atención?"
          (keydown.enter)="$event.preventDefault(); search()">
        </textarea>
        @if (articleForm.get('question')?.hasError('required') && articleForm.get('question')?.touched) {
          <mat-error>La pregunta es obligatoria</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-28 flex-shrink-0">
        <mat-label>Ambiente</mat-label>
        <mat-select formControlName="environment">
          <mat-option value="QA">QA</mat-option>
          <mat-option value="PROD">PROD</mat-option>
        </mat-select>
      </mat-form-field>

      <button
        type="button"
        (click)="search()"
        [disabled]="articleForm.invalid || loading()"
        class="h-14 px-5 bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary font-medium rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 flex-shrink-0">
        @if (loading()) {
          <mat-spinner diameter="16" color="primary"></mat-spinner>
        } @else {
          <lucide-angular [img]="Search" class="w-4 h-4"></lucide-angular>
        }
        <span>Buscar</span>
      </button>
    </form>

    <!-- Empty state -->
    @if (!result() && !loading() && !error()) {
      <div class="flex flex-col items-center justify-center h-48 text-light-text-tertiary dark:text-dark-text-tertiary gap-3">
        <lucide-angular [img]="FlaskConical" class="w-10 h-10 opacity-40"></lucide-angular>
        <p class="text-sm !mb-0">Ingresa una pregunta y presiona Buscar para probar el funcionamiento de la tool de Knowledge Base.</p>
      </div>
    }

    <!-- Loading state -->
    @if (loading()) {
      <div class="flex flex-col items-center justify-center h-48 gap-3">
        <mat-spinner diameter="36"></mat-spinner>
        <p class="text-sm text-light-text-tertiary dark:text-dark-text-tertiary !mb-0">Consultando retrieval...</p>
      </div>
    }

    <!-- Error state -->
    @if (error()) {
      <div class="bg-light-accent/10 dark:bg-dark-accent/10 border border-light-accent/30 dark:border-dark-accent/30 rounded-lg p-4 text-light-accent dark:text-dark-accent text-sm">
        {{ error() }}
      </div>
    }

    <!-- Results -->
    @if (result()) {
      <app-article-list [sections]="articleSections()"></app-article-list>
    }

  </mat-dialog-content>

  @if (data.showProceedButton) {
    <div class="flex-shrink-0 border-t border-light-border dark:border-dark-border">
      <!-- Warning banner -->
      <div class="flex items-start gap-3 px-6 py-3 bg-light-warning/10 dark:bg-dark-warning/10 border-b border-light-warning/20 dark:border-dark-warning/20">
        <lucide-angular [img]="TriangleAlert" class="w-4 h-4 text-light-warning dark:text-dark-warning flex-shrink-0 mt-0.5"></lucide-angular>
        <p class="text-sm text-light-warning dark:text-dark-warning !mb-0">
          Se encontraron artículos con alta similitud (&gt;80%). Revísalos antes de continuar para evitar duplicados.
        </p>
      </div>
      <!-- Actions -->
      <div class="flex justify-end gap-3 px-6 py-4">
        <button
          type="button"
          (click)="close()"
          class="h-10 px-6 font-medium rounded-xl !text-light-text-secondary dark:!text-dark-text-secondary hover:bg-light-bg-tertiary dark:hover:bg-dark-surface-variant transition-colors">
          Cancelar
        </button>
        <button
          type="button"
          (click)="proceed()"
          class="h-10 px-6 font-medium rounded-xl bg-light-warning/15 dark:bg-dark-warning/15 text-light-warning dark:text-dark-warning hover:opacity-90 transition-opacity">
          Guardar de todas formas
        </button>
      </div>
    </div>
  }
</div>
